import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import './SaveCollectionModal.scss';

import DropDownColor from "../../uiComponents/DropDownColor";
import UniversalButton from "../../uiComponents/UniversalButton";

import {ModalContext} from "../../ModalContext";
import {createTempCollectionFromSelection, getCollectionsForFolder} from "../../../utils/builder/IScheduleLogic";
import DropDownFolder from "../../uiComponents/DropDownFolder";
import {
  collectionDelete,
  collectionEdit,
  collectionSave,
  createCollectionFolder
} from "../../../store/actions/collections";
import {showToast} from "../../../utils/helpers";

const SaveCollectionModal = ({ type="create", folderInfo=null, tableInfo, selected}) => {

  const collection = {
    folder: folderInfo?.folder  || "My selection sets",
    collectionName: folderInfo?.title || "",
    description: folderInfo?.description || "",
    color: folderInfo?.color || "#4F80FF"
  }

  const dispatch = useDispatch();

  const { selection, collectionsFolders, activeFolder } = useSelector((state) => state.viewer);
  const { tabs } = useSelector((state) => state.table);

  const [infoAboutCollection, setInfoAboutCollection] = useState(collection);
  const [nameError, setNameError] = useState(null);

  const { handleModal } = useContext(ModalContext);

  const handleCancel = () => {
    handleModal(null, true);
  };

  const getSelectFolder = (folderName)=> {
    setInfoParameter({folder: folderName});
  }

  const saveCollection = async () => {
    const elements = tableInfo.lineElements.flat(2);

    const isValid = await validateCollectionName();

    if(isValid) {
      try {
        await dispatch(collectionSave({
            ...infoAboutCollection,
            elements,
            properties: tableInfo?.collection?.properties || selection.properties,
            groups: tableInfo?.collection?.groupBy || selection.groups,
            id: tableInfo?.id,
            type: tableInfo?.type,
            activeFolder,
            selected}));
        showToast(true,"Selection set was created");
      } catch (error) {
        showToast(false, error);
      }
      handleCancel();
    }
  }

  const editCollection = async () => {
    const isValid = await validateCollectionName();

    if(isValid) {
      try {
        await dispatch(collectionEdit({
          oldTitle: collection.collectionName,
          oldFolder: collection.folder,
          newTitle: infoAboutCollection.collectionName,
          newFolder: infoAboutCollection.folder,
          newDescription: infoAboutCollection.description,
          newColor: infoAboutCollection.color }));
        showToast(true,"Selection set was edited");
      } catch (error) {
        showToast(false, error);
      }
      handleCancel();
    }
  }

  const validateCollectionName = async () => {
    const collectionName = infoAboutCollection.collectionName;
    const folder = infoAboutCollection.folder;
    const collections = await getCollectionsForFolder(folder);

    const isExistName = collections.every((collection) => {
      return collection.title !== collectionName
    });

    if(!collectionName) {
      setNameError("The selection set name cannot be empty");
      return false;
    }
    if (!isExistName && type === "create") {
      setNameError("This name already exists");
      return false;
    }

    return true;
  }

  const addFolder = async (folderName) => {
    try {
      await dispatch(createCollectionFolder(folderName));
      setInfoParameter({folder: folderName});
      showToast(true,"Selection sets folder was created");
    } catch (error) {
      showToast(false, error);
    }
  }

  const setInfoParameter = (value) => {
    setInfoAboutCollection({...infoAboutCollection, ...value })
  }

  return (
    <div className="save-collection">
      <div className="save-collection__header">{`${type === "create" ? "Save" : "Edit"} selection set`}</div>
      <div className="save-collection__name">
        <label htmlFor="save-collection__name">Selection set name</label>
        <input id="save-collection__name"
               className={nameError ? "save-collection__input-error" : ""}
               type="text"
               value={infoAboutCollection.collectionName}
               onInput={(event) => setInfoParameter({collectionName: event.target.value})}/>
        {
          nameError && <div className="save-collection__error-text">{nameError}</div>
        }
      </div>
      <div className="save-collection__description">
        <label htmlFor="save-collection__description">
          Description <span className="save-collection__description_gray">(optional)</span>
        </label>
        <textarea id="save-collection__description" rows="3"
                  value={infoAboutCollection.description}
                  onInput={(event) => setInfoParameter({description: event.target.value})}>
        </textarea>
      </div>
      <div className="save-collection__folder">
        <DropDownFolder listTitle={infoAboutCollection.folder} list={collectionsFolders} getSelectFolder={getSelectFolder} addFolder={addFolder}/>
      </div>
      <div className="save-collection__color">
        <DropDownColor submitClick={setInfoParameter} color={infoAboutCollection.color}/>
      </div>
      <div className="save-collection__btns">
        <div className="save-collection__btns_btn">
          <UniversalButton
            type="button"
            label="Cancel"
            size="lg"
            labelColor="blue"
            labelHoverColor="blue"
            backgroundColor="white"
            backgroundHoverColor="blue-light"
            onClick={handleCancel}
          />
        </div>

        <UniversalButton
          type="button"
          label="Save"
          size="lg"
          labelColor="white"
          labelHoverColor="white"
          backgroundColor="orange"
          backgroundHoverColor="orange-light"
          onClick={type === "create" ? saveCollection : editCollection}
        />
      </div>
    </div>
  );
};

export default SaveCollectionModal;